import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {ApolloProvider} from "@apollo/client";
import {apolloClient} from "app/client/apollo";
import {BrowserRouter} from "react-router";
import {App} from "app/App";
import {ConfigProvider, ThemeConfig} from "antd";
import {GlobalStateProvider} from "app/user/GlobalStateProvider";
import {StyleProvider} from "@ant-design/cssinjs";

const domNode = document.getElementById("root")!;
const root = createRoot(domNode);

const theme: ThemeConfig = {
  token: {
    fontFamily:
      "-apple-system, BlinkMacSystemFont, Segoe UI, Noto Sans, Roboto, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji"
  }
};
root.render(
  <StrictMode>
    <ApolloProvider client={apolloClient}>
      <BrowserRouter>
        <StyleProvider layer>
          <ConfigProvider theme={theme}>
            <GlobalStateProvider>
              <App />
            </GlobalStateProvider>
          </ConfigProvider>
        </StyleProvider>
      </BrowserRouter>
    </ApolloProvider>
  </StrictMode>
);
